import { ConcreteEncodable } from "./ConcreteEncodable";

import { OrderFillDataImplEncoder } from "../../encoder/OrderFillDataImplEncoder";

import * as CubiqTS from "../../index";
import { OrderFillData } from "../OrderFillData";

export class OrderFillDataImpl extends ConcreteEncodable implements OrderFillData {
  public static enType: string = "com.bcdfx.model.event.lifecycle.OrderFillDataImpl";

  /*FID=1*/
  public orderId: string;
  /*FID=2*/
  public fillData: CubiqTS.RateData | null = null;
  /*FID=3*/
  public fillAmount: CubiqTS.BigNumber | null = null;
  /*FID=4*/
  public stpType: CubiqTS.FillStpType;
  /*FID=5*/
  public stpHold: boolean;
  /*FID=6*/
  public valueDate: CubiqTS.moment.Moment | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = OrderFillDataImplEncoder.Instance;
    this.setEncodableType(OrderFillDataImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "OrderFillDataImpl[" +
      "orderId=" +
      this.orderId +
      "fillData=" +
      this.fillData +
      "fillAmount=" +
      this.fillAmount +
      "stpType=" +
      this.stpType +
      "stpHold=" +
      this.stpHold +
      "valueDate=" +
      this.valueDate +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
